const mockPolls = [
  {
    id: '1',
    question: 'Should companies offer 4-day work weeks?',
    category: 'Workplace',
    tags: ['Workplace', 'HR'],
    votes: 120,
    closeDate: '2025-07-25',
    trending: true,
    createdAt: '2025-07-10'
  },
  {
    id: '2',
    question: 'Is AI a threat or opportunity?',
    category: 'Tech',
    tags: ['AI', 'Tech'],
    votes: 280,
    closeDate: '2025-08-01',
    trending: false,
    createdAt: '2025-07-16'
  },
  {
    id: '3',
    question: 'Should voting be mandatory?',
    category: 'Politics',
    tags: ['Civic', 'Politics'],
    votes: 45,
    closeDate: '2025-07-30',
    trending: false,
    createdAt: '2025-07-17'
  }
];

export default mockPolls;